export const FETCH_SUGGESTIONS = 'FETCH_SUGGESTIONS';
export const FETCH_SUGGESTIONS_SUCCESS = 'FETCH_SUGGESTIONS_SUCCESS';
export const FETCH_SUGGESTIONS_ERROR = 'FETCH_SUGGESTIONS_ERROR';

export const CLEAN_SUGGESTIONS_STORE = 'CLEAN_SUGGESTIONS_STORE';
